import React, { Fragment } from 'react'
import { isMobile } from 'react-device-detect'
import GeneralPopup from '@views/Popup/General'
import ComponentBetSlip from '@views/Popup/ComponentBetSlip'
import PickPurchase from '@views/Popup/PickPurchase'
import MissionPopup from '@views/Popup/Mission'
import ItemHistoryPopup from '@views/Popup/ItemHistory'
import MatchupDetailOneFold from '@views/Popup/OneFold/MatchupDetailOneFold'
import Attendance from './Event/Attendance'
import GiftBox from './Event/GiftBox'
import VocPopup from './Event/VocPopup'
import PartnershipBannerPopup from './Event/PartnershipBanner'
import UpdatePopup from './Event/Update'
import Message from './Message'
import Setting from './Setting'
import Telegram from './Telegram'
import VocPagePopup from './VocPagePopup'
import ChangeRate from './ChangeRate'
import GuidePopup from './GuidePopup'
import CouponPopup from './Coupon'
import OneFoldPopup from './OneFold'
import MatchupBannerPopup from './MatchupBanner'
import InitialPopup from './InitialPopup'
import BettingRulesDetail from './BettingRulesDetail'
import NoticeDetail from './NoticeDetail'
import BettingListSelectorPopup from './MessageContentPopup/BettingListSelectorPopup'
import BetSuccessPopup from './BetSuccess'
import SameMatchPopup from './SameMatch'
import ChangeProfilePopup from './ChangeProfile'
import ProfileImgViewPopup from './ProfileImgView'
import SettingLimitPopup from './SettingLimit'
import SelectCertificationPopup from './SettingLimit/SelectCertification'
import BubbleBetListPopup from './BubbleBetList'
import QuickMessagePopup from './QuickMessage'
import SelectLiveMatchTypePopup from './Chat/ChatLiveScore/SelectLiveMatchTypePopup'
import TutorialPopup from './Tutorial'
import TutorialVideoPopup from './TutorialVideo'
import BaccaratGuidePopup from './AdvCasinoPopup/BaccaratGuide'
import AdvCasinoOpenPopup from './AdvCasinoPopup/AdvCasinoOpen'
import ChargingCompletePopup from './ChargingComplete'
import BetCancelFailPopup from './BetCancelFailPopup'
import TipDetailPopup from './TipDetail'
import UrgencyMessagePopup from './UrgencyMessagePopup'
import { CompanyPickDetailPopup } from './CompanyPickDetail'
import MatchUpFilterPagePopup from './MatchupFilter/MatchupFilterPopup'
import Dialog from './Dialog'
import useRootStore from '@store/useRootStore'
import { observer } from 'mobx-react'
import { ActivityScoreNoticePopup } from 'containers/views/Popup/ActivityScoreNoticePopup'
import AccountTransferInfoPopup from '@views/Popup/AccountTransferInfoPopup'
import MatchUpBottomBanner from '@views/Matchup/MatchUpBottomBanner'
import { USER_ACTIVITY_TYPE } from '@v2/constants/activity'

const PopupLayout: React.FC = props => {
  const { globalStore, chattingStore} = useRootStore()
  const { generalPopupQueue, dialogQueue, activityScoreNoticeQueue } = globalStore
  /*
  [테스트내용] 채팅(MO)의 <ActivityScoreNoticePopup/> 스타일 수정을 위해 작성한 코드입니다.
  [이슈링크] (https://task.zempublic.co.kr/view.php?id=9591)
  */
  let activityTypeEle
  for (const userActivityInfo of activityScoreNoticeQueue) {
    const { activityType } = userActivityInfo
    activityTypeEle = activityType
  }

  const isMobileChatting = ((activityTypeEle === USER_ACTIVITY_TYPE.BET_HISTORY_SHARED_TO_CHAT)
    || (activityTypeEle === USER_ACTIVITY_TYPE.CHEER_FOR_TEAM)) && isMobile && chattingStore.isVisibleChattingModal

  return (
    <Fragment>
      <ChangeRate/>
      <Attendance/>
      <GiftBox/>
      <VocPopup/>
      <PartnershipBannerPopup/>
      <UpdatePopup/>
      <Message/>
      <Setting/>
      {/*텔레그램 알림설정 팝업*/}
      <Telegram/>
      <PickPurchase/>
      {isMobile && <ComponentBetSlip/>}
      <MissionPopup/>
      <GuidePopup/>
      <ItemHistoryPopup/>
      <CouponPopup/>
      <OneFoldPopup/>
      <MatchupDetailOneFold/>
      <MatchupBannerPopup/>
      <VocPagePopup/>
      <InitialPopup/>
      <BettingRulesDetail/>
      <NoticeDetail/>
      <BettingListSelectorPopup/>
      <BetSuccessPopup/>
      <SameMatchPopup/>
      <ChangeProfilePopup/>
      <ProfileImgViewPopup/>
      <SettingLimitPopup/>
      <SelectCertificationPopup/>
      <BubbleBetListPopup/>
      <QuickMessagePopup/>
      <SelectLiveMatchTypePopup/>
      <TutorialPopup/>
      <TutorialVideoPopup/>
      <BaccaratGuidePopup/>
      <AdvCasinoOpenPopup/>
      <ChargingCompletePopup/>
      <BetCancelFailPopup/>
      <TipDetailPopup/>
      <UrgencyMessagePopup/>
      <CompanyPickDetailPopup/>
      <MatchUpFilterPagePopup/>
      <AccountTransferInfoPopup/>
      {generalPopupQueue.map(popup => {
        return <GeneralPopup key={popup.popupId} {...popup}/>
      })}
      {dialogQueue.map(dialog => {
        return <Dialog key={dialog.id} {...dialog}/>
      })}
      {!isMobileChatting &&
        <ActivityScoreNoticePopup/>
      }
      <MatchUpBottomBanner/>
    </Fragment>
  )
}

export default observer(PopupLayout)
